/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { TemplatesQuoteTemplateSubHeader_QuoteTemplateFragmentDoc, TemplatesQuoteTemplateSubHeader_QuoteTemplateItemFragmentDoc } from '../../../features/templates/quote/TemplatesQuoteTemplateSubHeader.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type TemplateQuoteRoutesQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type TemplateQuoteRoutesQuery = { quoteTemplateLatest: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'QuoteTemplateLatestResult', quoteTemplate?: { __typename: 'QuoteTemplate', id: string, resolvedAsReadModelVersionNumber?: number | null, owningSystemOrganisationId: string, title: string, projectId?: string | null, customizable: boolean, has3dRoomSnapshot: boolean, latestPublishedVersionNumber?: number | null, containsUnpublishedChanged: boolean, hasAnyPublishedVersion: boolean, accessType: Types.TemplateAccessType, isBinding: boolean, usedInOtherTemplates: boolean, rootItem: { __typename: 'Item', id: string, originVersionNumber?: number | null, type: Types.ItemType }, templateSharing?: { __typename: 'TemplateSharing', id: string, latestSharedVersionNumber: number, sharedPublicly: boolean, templateId: string, subscribedToTemplate?: { __typename: 'TemplateSubscription', subscribedVersionNumber: number, updateAvailable: boolean } | null, sharedWithOrganisations: Array<{ __typename: 'Company', id: string, title: string, logo?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null }> } | null } | null } };


export const TemplateQuoteRoutesDocument = gql`
    query TemplateQuoteRoutes($id: ID!) {
  quoteTemplateLatest(id: $id) {
    ... on QuoteTemplateLatestResult {
      quoteTemplate {
        id
        resolvedAsReadModelVersionNumber
        owningSystemOrganisationId
        title
        projectId
        ...TemplatesQuoteTemplateSubHeader_QuoteTemplate
        rootItem {
          id
          originVersionNumber
          ...TemplatesQuoteTemplateSubHeader_QuoteTemplateItem
        }
      }
    }
  }
}
    ${TemplatesQuoteTemplateSubHeader_QuoteTemplateFragmentDoc}
${TemplatesQuoteTemplateSubHeader_QuoteTemplateItemFragmentDoc}`;

/**
 * __useTemplateQuoteRoutesQuery__
 *
 * To run a query within a React component, call `useTemplateQuoteRoutesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplateQuoteRoutesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplateQuoteRoutesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTemplateQuoteRoutesQuery(baseOptions: Apollo.QueryHookOptions<TemplateQuoteRoutesQuery, TemplateQuoteRoutesQueryVariables> & ({ variables: TemplateQuoteRoutesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TemplateQuoteRoutesQuery, TemplateQuoteRoutesQueryVariables>(TemplateQuoteRoutesDocument, options);
      }
export function useTemplateQuoteRoutesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TemplateQuoteRoutesQuery, TemplateQuoteRoutesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TemplateQuoteRoutesQuery, TemplateQuoteRoutesQueryVariables>(TemplateQuoteRoutesDocument, options);
        }
export function useTemplateQuoteRoutesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TemplateQuoteRoutesQuery, TemplateQuoteRoutesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TemplateQuoteRoutesQuery, TemplateQuoteRoutesQueryVariables>(TemplateQuoteRoutesDocument, options);
        }
export type TemplateQuoteRoutesQueryHookResult = ReturnType<typeof useTemplateQuoteRoutesQuery>;
export type TemplateQuoteRoutesLazyQueryHookResult = ReturnType<typeof useTemplateQuoteRoutesLazyQuery>;
export type TemplateQuoteRoutesSuspenseQueryHookResult = ReturnType<typeof useTemplateQuoteRoutesSuspenseQuery>;
export type TemplateQuoteRoutesQueryResult = Apollo.QueryResult<TemplateQuoteRoutesQuery, TemplateQuoteRoutesQueryVariables>;